package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.PlaygroundW500Rounded: ImageVector
    get() {
        if (_playgroundW500Rounded != null) {
            return _playgroundW500Rounded!!
        }
        _playgroundW500Rounded = Builder(name = "PlaygroundW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(75.17f, 848.13f)
                quadToRelative(-19.15f, 0.0f, -31.94f, -13.17f)
                quadToRelative(-12.8f, -13.18f, -12.8f, -32.33f)
                quadToRelative(0.0f, -17.48f, 11.15f, -29.7f)
                quadToRelative(11.14f, -12.21f, 27.66f, -14.13f)
                horizontalLineToRelative(1.52f)
                lineTo(106.0f, 230.46f)
                quadToRelative(2.0f, -33.44f, 26.2f, -56.01f)
                quadToRelative(24.19f, -22.58f, 57.55f, -22.58f)
                horizontalLineToRelative(255.43f)
                quadToRelative(33.36f, 0.0f, 57.56f, 22.58f)
                quadToRelative(24.19f, 22.57f, 26.19f, 56.01f)
                lineToRelative(36.0f, 526.67f)
                horizontalLineToRelative(155.55f)
                verticalLineToRelative(-240.26f)
                quadToRelative(-52.72f, -14.72f, -86.48f, -57.91f)
                quadToRelative(-33.76f, -43.2f, -33.76f, -100.39f)
                quadToRelative(0.0f, -34.72f, 13.0f, -64.7f)
                quadToRelative(13.0f, -29.98f, 36.0f, -52.7f)
                quadToRelative(-4.74f, -11.0f, -6.63f, -22.0f)
                quadToRelative(-1.89f, -11.0f, -1.89f, -23.0f)
                quadToRelative(0.0f, -51.79f, 36.18f, -88.05f)
                quadToRelative(36.18f, -36.25f, 87.87f, -36.25f)
                quadToRelative(51.69f, 0.0f, 88.0f, 36.25f)
                quadToRelative(36.32f, 36.26f, 36.32f, 88.05f)
                quadToRelative(0.0f, 12.0f, -1.95f, 23.0f)
                reflectiveQuadToRelative(-6.81f, 22.0f)
                quadToRelative(23.0f, 22.72f, 36.12f, 52.75f)
                quadToRelative(13.12f, 30.03f, 13.12f, 64.65f)
                quadToRelative(0.0f, 57.19f, -33.89f, 100.39f)
                quadToRelative(-33.88f, 43.19f, -86.59f, 57.91f)
                verticalLineToRelative(240.26f)
                horizontalLineToRelative(74.74f)
                quadToRelative(19.15f, 0.0f, 32.32f, 13.17f)
                quadToRelative(13.18f, 13.18f, 13.18f, 32.33f)
                reflectiveQuadToRelative(-13.18f, 32.33f)
                quadToRelative(-13.17f, 13.17f, -32.32f, 13.17f)
                lineTo(75.17f, 848.13f)
                close()
                moveTo(160.13f, 757.13f)
                horizontalLineToRelative(315.44f)
                lineToRelative(-35.0f, -516.65f)
                horizontalLineToRelative(-30.09f)
                verticalLineToRelative(359.56f)
                quadToRelative(12.28f, 4.2f, 20.06f, 15.27f)
                quadToRelative(7.79f, 11.08f, 7.79f, 25.17f)
                quadToRelative(0.0f, 18.67f, -12.82f, 31.49f)
                quadToRelative(-12.81f, 12.81f, -31.49f, 12.81f)
                lineTo(241.91f, 684.78f)
                quadToRelative(-18.67f, 0.0f, -31.49f, -12.81f)
                quadToRelative(-12.81f, -12.82f, -12.81f, -31.49f)
                quadToRelative(0.0f, -14.09f, 7.9f, -25.17f)
                quadToRelative(7.9f, -11.07f, 20.19f, -15.27f)
                verticalLineToRelative(-359.56f)
                horizontalLineToRelative(-30.57f)
                lineToRelative(-35.0f, 516.65f)
                close()
                moveTo(290.48f, 596.17f)
                horizontalLineToRelative(55.22f)
                verticalLineToRelative(-355.69f)
                horizontalLineToRelative(-55.22f)
                verticalLineToRelative(355.69f)
                close()
                moveTo(764.78f, 432.59f)
                quadToRelative(31.42f, 0.0f, 53.8f, -22.31f)
                quadToRelative(22.38f, -22.3f, 22.38f, -53.63f)
                quadToRelative(0.0f, -26.8f, -12.64f, -41.32f)
                quadToRelative(-12.65f, -14.53f, -26.65f, -28.43f)
                verticalLineToRelative(-87.38f)
                quadToRelative(0.0f, -15.68f, -10.6f, -26.28f)
                quadToRelative(-10.61f, -10.61f, -26.29f, -10.61f)
                quadToRelative(-15.57f, 0.0f, -26.11f, 10.61f)
                quadToRelative(-10.54f, 10.6f, -10.54f, 26.28f)
                verticalLineToRelative(87.38f)
                quadToRelative(-14.0f, 13.9f, -26.52f, 28.43f)
                quadToRelative(-12.52f, 14.52f, -12.52f, 41.32f)
                quadToRelative(0.0f, 31.33f, 22.23f, 53.63f)
                quadToRelative(22.24f, 22.31f, 53.46f, 22.31f)
                close()
                moveTo(765.02f, 356.65f)
                close()
            }
        }
        .build()
        return _playgroundW500Rounded!!
    }

private var _playgroundW500Rounded: ImageVector? = null
